export const PlantItemRenewalFindPage = {
  searchByOptions: [
    {
      label: 'Renewal number',
      value: 'renewalNumber',
    },
    {
      label: 'Item registration number',
      value: 'itemRegistrationNumber',
    },
  ],
  searchByLabel: 'Search by:',
  renewalNumberLabel: 'Renewal number',
  renewalNumberHelpMessage: 'Your renewal number starts with PIR-',
  itemRegistrationNumberLabel: 'Item registration number',
  postcodeLabel: 'Postcode of item location',
  tooEarlyRenewalNumberErrorTitle: "We couldn't find this renewal number.",
  tooEarlyRenewalNumberErrorMessage: `<p>Here are possible some reasons:
  <ul>
  <li>You entered the renewal number incorrectly. Check your renewal number and try again</li>
  <li>The renewal number is no longer valid. You can try searching by item registration number.</li>
  </ul>
  </p>
  <p>For help, call SafeWork NSW on 13 10 50.</p>`,
  tooEarlyRenewalNumberFieldError: 'We could not find this renewal number.',

  tooLateRenewalNumberErrorTitle: "We couldn't find this renewal number.",
  tooLateRenewalNumberErrorMessage: `<p>Here are possible some reasons:
  <ul>
  <li>You entered the renewal number incorrectly. Check your renewal number and try again</li>
  <li>The renewal number is no longer valid. You can try searching by item registration number.</li>
  </ul>
  </p>
  <p>For help, call SafeWork NSW on 13 10 50.</p>`,
  tooLateRenewalNumberFieldError: 'We could not find this renewal number.',

  tooEarlyRegoNumberErrorTitle: 'Your item registration is not due for renewal',
  tooEarlyRegoNumberErrorMessage: `<p>You will get an email or letter reminder when it's time to renew.</p>
  <p>For help, call SafeWork NSW on 13 10 50.</p>
  `,
  tooEarlyRegoNumberFieldError: 'This item registration is not due for renewal.',

  tooLateRegoNumberErrorTitle: 'You cannot renew this item registration',
  tooLateRegoNumberErrorMessage: `<p>You can search for another item registration at the same location.</p>
    <p>If you want to use the item, you can apply for a new item registration.</p>
    <p>For help, call Safework NSW on 13 10 50.</p>`,
  tooLateRegoNumberFieldError: 'You cannot renew this item registration.',

  cannotRenewRegoNumberErrorTitle: 'You cannot renew this item registration',
  cannotRenewRegoNumberErrorMessage: `<p>You can search for another item registration at the same location.</p>
    <p>If you want to use the item, you can apply for a new item registration.</p>
    <p>For help, call Safework NSW on 13 10 50.</p>`,
  cannotRenewRegoNumberFieldError: 'You cannot renew this item registration.',

  renewalNotFoundErrorTitle: "We couldn't find this renewal number.",
  renewalNotFoundErrorMessage: `<p>Here are possible some reasons:
  <ul>
  <li>You entered the renewal number incorrectly. Check your renewal number and try again</li>
  <li>The renewal number is no longer valid. You can try searching by item registration number.</li>
  </ul>
  </p>
  <p>For help, call SafeWork NSW on 13 10 50.</p>`,
  renewalNotFoundFieldError: 'We could not find this renewal number.',

  regoNotFoundErrorTitle: 'The item registration number you entered is either incorrect or does not match the postcode',
  regoNotFoundErrorMessage: `<p>Check the details you entered and try again. The postcode must be for the location of the plant item.</p>
  <p>For help, call SafeWork NSW on 13 10 50.</p>`,

  missingPropertyErrorTitle: 'We could not confirm the location address of your item(s).',
  missingPropertyErrorMessage: 'Please call SafeWork NSW on 13 10 50 to update your details.',

  inProgressRenewalNumberErrorTitle: 'This renewal is already in progress.',
  inProgressRenewalNumberErrorMessage:
    'Check if someone else is completing this renewal. For help, call SafeWork NSW on 13 10 50.',
  inProgressRenewalNumberFieldError: 'This renewal number is linked to an application in progress.',

  inProgressRegoNumberErrorTitle:
    'You cannot proceed with this renewal. An application has already been started online.',
  inProgressRegoNumberErrorMessage:
    'Please check if someone else has started this renewal or a payment might be underway.',
  inProgressRegoNumberFieldError: 'Details match an existing application.',
};
